let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2yKhM")).then(() => parcelRequire('e5Gv4'));